@if (appleTVDisplays && nonAppleTVPresentations) {
  <div class="tw-m-[15px]">
    <notification-alert
      type="warning"
      title="Apple TV Compatibility Warning"
      message="One or more playlist items in your schedule will not play on your Apple TV."
    >
    </notification-alert>
  </div>
}
<div
  class="schedule-fields-body fields-preview-panels tw-flex tw-flex-col lg:!tw-flex-row"
>
  <div
    class="preview-container tw-h-full tw-flex tw-flex-col tw-items-center tw-flex-[2] tw-bg-gray-100"
  >
    <div
      class="tw-w-full lg:tw-max-w-[768px] tw-flex tw-flex-col tw-px-[15px] tw-pt-[15px] xl:!tw-pt-[60px]"
    >
      <timeline-textbox
        [useLocaldate]="true"
        [(timelineObject)]="scheduleService.schedule"
        [readonly]="isAssignedPublisher"
        [showLabel]="true"
        [showScheduleDisclaimer]="true"
        inputId="-schedule"
        class="tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-pb-5 tw-mb-2.5"
      >
      </timeline-textbox>
      <distribution-selector
        [(distribution)]="scheduleService.schedule.distribution"
        (distributionChange)="checkLicenseRequired()"
        [(subcompanyDistribution)]="
          scheduleService.schedule.subcompanyDistribution
        "
        [(distributeToSubcompanies)]="
          scheduleService.schedule.distributeToSubcompanies
        "
        (distributeToSubcompaniesChange)="distributeToSubcompaniesChange()"
        [(distributeToAll)]="scheduleService.schedule.distributeToAll"
        (distributeToAllChange)="checkLicenseRequired()"
        [enableSubcompanies]="true"
        [readonly]="isAssignedPublisher"
        [showLabel]="true"
        inputId="-schedule"
        class="tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-py-5 tw-mb-2.5"
      >
      </distribution-selector>
      <div
        class="danger tw-mt-[5px]"
        [shown]="
          freeDisplays?.length &&
          licenseRequired &&
          !playerLicenseService.updatingLicense &&
          !playerLicenseService.apiError
        "
      >
        You selected {{ freeDisplays?.length }} unlicensed display{{
          freeDisplays?.length > 1 ? 's' : ''
        }}
        that won't show content.
        <a
          rv-link
          appearance="inline"
          actionLink
          (click)="licenseFreeDisplays()"
          >License {{ freeDisplays?.length > 1 ? 'them' : 'it' }}?</a
        >
      </div>
      <div
        class="danger tw-mt-[5px]"
        [shown]="
          freeDisplays?.length &&
          !licenseRequired &&
          !playerLicenseService.updatingLicense &&
          !playerLicenseService.apiError
        "
      >
        You selected {{ freeDisplays?.length }} unlicensed display{{
          freeDisplays?.length > 1 ? 's' : ''
        }}.
        <a
          rv-link
          appearance="inline"
          actionLink
          (click)="licenseFreeDisplays()"
          >License {{ freeDisplays?.length > 1 ? 'them' : 'it' }}?</a
        >
      </div>
      <div class="tw-mt-[5px]" [shown]="playerLicenseService.updatingLicense">
        Assigning licenses
        <i aria-label="Loading" class="fa fa-spinner fa-spin fa-fw"></i>
      </div>
      <div class="danger tw-mt-[5px]" [shown]="playerLicenseService.apiError">
        {{ playerLicenseService.apiError }}
      </div>
      <schedule-type-selector
        [(scheduleType)]="scheduleService.schedule.scheduleType"
        (scheduleTypeChange)="scheduleTypeChange()"
        [(playOnce)]="scheduleService.schedule.playOnce"
        [readonly]="isAssignedPublisher"
        class="tw-mt-2.5"
      >
      </schedule-type-selector>
      @if (
        scheduleService.schedule.id && scheduleService.schedule?.content?.length
      ) {
        <div class="tw-text-right tw-mb-2.5" [shown]="isMobile">
          <button
            rv-button
            variant="secondary"
            class="tw-mr-2.5 xl:!tw-mr-0"
            (click)="isMobile = false"
          >
            Show Preview
          </button>
        </div>
        <div
          class="preview-embed tw-mr-2.5 xl:!tw-my-2.5 xl:!tw-mr-0"
          [hidden]="isMobile"
        >
          <iframe frameborder="0" [src]="isMobile ? '' : sanitizedPreviewUrl">
          </iframe>
        </div>
        <div
          class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-pt-[15px] tw-pb-[5px]"
        >
          <mat-slide-toggle
            id="applyTimeline"
            name="applyTimeline"
            [(ngModel)]="applyTimeline"
            >Apply Timeline to preview</mat-slide-toggle
          >
          <share-schedule-button
            class="tw-mr-2.5 xl:!tw-mr-0"
            buttonClass="tw-bg-white"
          ></share-schedule-button>
        </div>
      }
      <div
        id="insecureUrlsErrorBox"
        [shown]="scheduleService.hasInsecureUrls() && !scheduleService.apiError"
        class="madero-style alert alert-danger tw-mt-2.5"
        role="alert"
      >
        <strong
          >This schedule's playlist contains playlist items which can't show
          because the URL is insecure. Make sure the URLs begin with "HTTPS". If
          you need assistance, please email
          <a
            rv-link
            appearance="inline"
            target="_blank"
            href="mailto:support@risevision.com"
            >support&#64;risevision.com</a
          >.</strong
        >
      </div>
      <div
        id="errorBox"
        [shown]="scheduleService.apiError"
        class="madero-style alert alert-danger tw-mt-2.5"
        role="alert"
      >
        <strong>{{ scheduleService.apiError }}</strong>
      </div>
    </div>
  </div>

  <div
    class="tw-flex-1 tw-h-full tw-w-full lg:!tw-max-w-[33.33%] tw-overflow-y-auto tw-shadow-md"
  >
    <div
      class="tw-py-5 tw-flex tw-flex-row tw-items-center tw-border-0 tw-border-solid tw-border-b tw-border-gray-200"
    >
      <label class="tw-mb-0 tw-mr-auto tw-text-[15px] tw-pl-[15px]"
        >Playlist:</label
      >
      <div class="dropdown" dropdown>
        <button
          rv-button
          variant="secondary"
          id="addPlaylistItemButton"
          type="button"
          class="tw-mr-[15px] tw-shrink-0 tw-whitespace-nowrap"
          [matMenuTriggerFor]="playlistMenu"
        >
          <mat-icon svgIcon="add" aria-hidden="true"></mat-icon>
          <span id="addPlaylistItemButtonText">Add Playlist Item</span>
        </button>
        <mat-menu
          #playlistMenu="matMenu"
          aria-labelledby="addPlaylistItemButtonText"
        >
          <button
            mat-menu-item
            id="addPresentationItemButton"
            aria-label="Add Presentation Item"
            (click)="addPresentationItem()"
            (keyup.enter)="addPresentationItem()"
          >
            Presentation
          </button>
          <button
            mat-menu-item
            id="addUrlItemButton"
            aria-label="Add URL Item"
            (click)="addUrlItem()"
            (keyup.enter)="addUrlItem()"
          >
            URL
          </button>
        </mat-menu>
      </div>
    </div>
    <playlist
      [playlistItems]="scheduleService.schedule.content"
      [shown]="scheduleService.schedule?.content?.length"
    ></playlist>
    @if (!scheduleService.schedule?.content?.length) {
      <div
        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-mt-[30px]"
      >
        <div
          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-[70px] tw-py-[15px] tw-w-full"
        >
          <mat-icon
            svgIcon="playlist"
            class="tw-w-[50px] tw-h-[50px]"
          ></mat-icon>
          <div class="form-group tw-mb-2.5 tw-mt-[30px]">
            <p class="tw-text-[15px] tw-font-bold tw-text-center">
              Start by adding playlist items.
            </p>
            <p
              class="tw-text-gray-500 tw-mt-[5px] tw-text-[15px] tw-text-center"
            >
              Build your schedule by adding playlist items.<br />Organize your
              content to play exactly how you want.
            </p>
          </div>
          <div class="dropdown tw-my-[5px]" dropdown>
            <a
              rv-link
              id="addPlaylistItemButton"
              [matMenuTriggerFor]="playlistMenu"
              class="tw-text-[15px] tw-font-medium"
              tabindex="1"
            >
              Add Playlist Item
            </a>
            <mat-menu #playlistMenu="matMenu">
              <button
                mat-menu-item
                id="addPresentationItemButton"
                (click)="addPresentationItem()"
                (keyup.enter)="addPresentationItem()"
              >
                Presentation
              </button>
              <button
                mat-menu-item
                id="addUrlItemButton"
                (click)="addUrlItem()"
                (keyup.enter)="addUrlItem()"
              >
                URL
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    }
  </div>
</div>
